module.exports = __webpack_public_path__ + "assets/img/caigou.85bbb522.png";